import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { User } from 'domain/User'
import { LoginResponse } from '../../domain/LoginResponse'

const userSlice = createSlice({
    name: 'userSlice',
    initialState: {
        user: {} as User,
        loginToken: {} as LoginResponse,
    },
    reducers: {
        setUser: (state, action: PayloadAction<User>) => {
            state.user = action.payload
        },
        setLoginResponse: (state, action: PayloadAction<LoginResponse>) => {
            state.loginToken = action.payload
        },
    },
})

export const { setUser, setLoginResponse } = userSlice.actions
export default userSlice.reducer
